import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import styled, { css } from "styled-components";
import { AmazonLogoDark, AmazonLogoLight } from "../icon/components/logos/AmazonLogos";
import { WalmartLogo } from "../icon/components/logos/WalmartLogo";
import { WalmartLogoLight } from "../icon/components/logos/WalmartLogoLight";
export const MarketplaceBadge = forwardRef(({ colorType = "dark", platform = "AM", className }, ref) => {
    return (_jsx(Wrapper, { ref: ref, "$colorType": colorType, className: className, children: platformIcons[colorType][platform] }));
});
const themes = {
    dark: css `
    background: ${(p) => p.theme.systemColors.black};
  `,
    light: css `
    background: ${(p) => p.theme.systemColors.grey200};
  `,
};
const platformIcons = {
    dark: {
        AM: _jsx(AmazonLogoDark, {}),
        WM: _jsx(WalmartLogo, {}),
    },
    light: {
        AM: _jsx(AmazonLogoLight, {}),
        WM: _jsx(WalmartLogoLight, {}),
    },
};
const Wrapper = styled.div `
  ${(p) => themes[p.$colorType]};
  display: inline-flex;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  flex-shrink: 0;
  font-size: 12px;
`;
